<template>
  <!-- FOLKTALE 页面 -->
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <Banner :banner="bannerList" @click="loseFocus()"></Banner>
    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">护理系列</div>
      <ul>
        <li v-for="(item, index) in list1" :key="index">
          <a @click="toDetail(item.id)">
            <i>{{ item.sub1 }}</i>
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">洗护系列</div>
      <ul>
        <li v-for="(item, index) in list2" :key="index">
          <a @click="toDetail(item.id)">
            <i>{{ item.sub1 }}</i>
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">私护系列</div>
      <ul>
        <li v-for="(item, index) in list3" :key="index">
          <a @click="toDetail(item.id)">
            <i>{{ item.sub1 }}</i>
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">香氛系列</div>
      <ul>
        <li v-for="(item, index) in list4" :key="index">
          <a @click="toDetail(item.id)">
            <i>{{ item.sub1 }}</i>
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">其他系列</div>
      <ul>
        <li v-for="(item, index) in list5" :key="index">
          <a @click="toDetail(item.id)">
            <i>{{ item.sub1 }}</i>
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <hr class="hr_1 mb80" />
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id: '',
      login: false, //是否登录
      userInfo: [], //是否登录--用户信息
      bannerList: [
        { url: 'static/picture/FOLKTALE/banner/banner1.jpg' },
        { url: 'static/picture/FOLKTALE/banner/banner2.jpg' },
        { url: 'static/picture/FOLKTALE/banner/banner3.jpg' },
        { url: 'static/picture/FOLKTALE/banner/banner4.jpg' }
      ],
      list1: [
        { id: 1, title: '抽取式保湿纸巾', english: 'MOISTURIZING COTTON TISSUE', sub1: '温润舒爽', sub2: '绵软顺滑 轻润似水', url: 'static/picture/FOLKTALE/list/hl/hl (1).jpg' },
        { id: 2, title: '纯棉压缩面膜纸', english: 'COMPRESSED MASK SHEET', sub1: '肌肤慢享时光', sub2: '全棉材质 亲肤柔软', url: 'static/picture/FOLKTALE/list/hl/hl (2).jpg' },
        { id: 3, title: '大号盒装棉柔巾', english: 'COTTON SOFT TISSUE', sub1: '轻享柔软生活', sub2: '优选棉花 蓬松加厚', url: 'static/picture/FOLKTALE/list/hl/hl (3).jpg' },
        { id: 4, title: '可拉伸化妆棉', english: 'CONTRACTED COTTON', sub1: '柔韧覆盖肌肤', sub2: '质感棉柔 轻薄透气', url: 'static/picture/FOLKTALE/list/hl/hl (4).jpg' },
        { id: 5, title: '小号盒装棉柔巾', english: 'COTTON SOFT TISSUE', sub1: '轻享柔软生活', sub2: '优选棉花 蓬松加厚', url: 'static/picture/FOLKTALE/list/hl/hl (5).jpg' },
        { id: 6, title: '棉柔巾（便携装）', english: 'COTTON SOFT TISSUE', sub1: '轻享柔软生活', sub2: '优选棉花 蓬松加厚', url: 'static/picture/FOLKTALE/list/hl/hl (6).jpg' },
        { id: 7, title: '天丝压缩面膜纸', english: 'MASK SHEET', sub1: '肌肤慢享时光', sub2: '如丝透薄 更贴合肌肤', url: 'static/picture/FOLKTALE/list/hl/hl (7).jpg' }
      ],
      list2: [
        {
          id: 8,
          title: '焕亮洗发乳 海岛香氛',
          english: 'REVITALIZING SHAMPOO<br>SEA LAND FRAGRANCE',
          sub1: '芳香水生调',
          sub2: '温和净澈 轻盈蓬松',
          url: 'static/picture/FOLKTALE/list/sh/sh (1).jpg'
        },
        {
          id: 10,
          title: '轻盈洗发乳 绿茶香氛',
          english: 'FLUFFY SHAMPOO<br>GREEN TEA FRAGRANCE',
          sub1: '清新水生调',
          sub2: '植物精华 丰盈秀发',
          url: 'static/picture/FOLKTALE/list/sh/sh (3).jpg'
        },
        { id: 13, title: '柔亮顺发膜', english: 'SOFT AND SMOOTH HAIR MASK', sub1: '精油柔护', sub2: '深层滋养 修护盈润', url: 'static/picture/FOLKTALE/list/sh/sh (6).jpg' },
        {
          id: 11,
          title: '清柔沐浴乳 蒲公英域香氛',
          english: 'CLEAN AND SOFT BODY WASH<br>DANDELION FIELDS FRAGRANCE',
          sub1: '柔软清香',
          sub2: '清爽滋养 香味疗愈',
          url: 'static/picture/FOLKTALE/list/sh/sh (4).jpg'
        },
        {
          id: 12,
          title: '清柔沐浴乳 小苍梨香氛',
          english: 'CLEAN AND SOFT BODY WASH<br>dENGLISH PEAR & FREESIA FRAGRANCE',
          sub1: '柔滑馨香',
          sub2: '深层净澈 水润舒适',
          url: 'static/picture/FOLKTALE/list/sh/sh (5).jpg'
        },
        { id: 15, title: '滋润身体乳', english: 'MOIST BODY LOTION', sub1: '轻盈肤感', sub2: '盈润水感 持久留香', url: 'static/picture/FOLKTALE/list/sh/sh (8).jpg' }
      ],
      list3: [
        { id: 16, title: '女性卫生裤', english: 'SANITARY PANTS', sub1: '弹力柔软贴身', sub2: '瞬吸干爽 肆意翻身', url: 'static/picture/FOLKTALE/list/ssh/ssh (1).png' },
        {
          id: 17,
          title: '舒爽纯棉系列超长夜用卫生巾',
          english: 'REFRESHING & COTTON & HEAVY FLOW<br>NIGHTTIME SANITARY PADS',
          sub1: '100%日本进口纯棉',
          sub2: '棉柔呵护 长夜安心舒睡',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (2).png'
        },
        {
          id: 18,
          title: '舒爽纯棉系列日用卫生巾',
          english: 'REFRESHING & COTTON DAYTIME SANITARY PADS',
          sub1: '100%日本进口纯棉',
          sub2: '柔软亲肤 清爽瞬吸',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (3).png'
        },
        {
          id: 19,
          title: '舒爽纯棉系列卫生护垫',
          english: 'REFRESHING & COTTON PANTYLINER',
          sub1: '100%日本进口纯棉',
          sub2: '轻薄透气 小巧护理',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (4).png'
        },
        {
          id: 20,
          title: '舒爽纯棉系列夜用卫生巾',
          english: 'REFRESHING & COTTON NIGHTTIME SANITARY PADS',
          sub1: '100%日本进口纯棉',
          sub2: '绵柔丝滑 轻薄夜用',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (5).png'
        },
        {
          id: 21,
          title: '医护级蚕丝系列日用卫生巾',
          english: 'MEDICAL GRADE & SILK DAYTIME SANITARY PADS',
          sub1: '医护级卫生巾',
          sub2: '干爽透气 拒绝潮闷感',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (6).png'
        },
        {
          id: 22,
          title: '医护级蚕丝系列夜用卫生巾',
          english: 'MEDICAL GRADE & SILK NIGHTTIME SANITARY PADS',
          sub1: '医护级卫生巾',
          sub2: '告别侧漏 无惧潮涌意外',
          url: 'static/picture/FOLKTALE/list/ssh/ssh (7).png'
        },
        { id: 33, title: '安心套组', english: 'COMFORT SUITS', sub1: '全周期舒柔呵护', sub2: '舒适绵柔 日夜兼护', url: 'static/picture/FOLKTALE/list/ssh/ssh (8).png' }
      ],
      list4: [
        {
          id: 23,
          title: '海岛扩散香薰',
          english: 'ISLAND AMBIANCE DIFFUSER',
          sub1: '清新海风弥漫',
          sub2: '柑橘果香 安稳木质感',
          url: 'static/picture/FOLKTALE/list/xh/xh (1).png'
        },
        {
          id: 25,
          title: '绿茶扩散香薰',
          english: 'TEALIZZY AMBIANCE DIFFUSER',
          sub1: '温暖穿透藤蔓',
          sub2: '清新柑橘 清澈铃兰',
          url: 'static/picture/FOLKTALE/list/xh/xh (3).png'
        },
        {
          id: 31,
          title: '英国小苍梨扩散香薰',
          english: 'ENGLISH PEAR FREESIA AMBIANCE DIFFUSER',
          sub1: '初遇雨后森林',
          sub2: '清新香柠 温柔涤荡',
          url: 'static/picture/FOLKTALE/list/xh/xh (9).png'
        },
        {
          id: 29,
          title: '泌密忍冬&格蓬扩散香薰',
          english: 'HONEYSUCKLE & GALBANUM AMBIANCE DIFFUSER',
          sub1: '柔和明朗交织',
          sub2: '绵长茉莉 深沉檀香',
          url: 'static/picture/FOLKTALE/list/xh/xh (7).png'
        },
        {
          id: 27,
          title: '蒲公英域扩散香薰',
          english: 'DANDELION FIELDS AMBIANCE DIFFUSER',
          sub1: '永不停歇的爱',
          sub2: '微暖雪松 凛冽木香',
          url: 'static/picture/FOLKTALE/list/xh/xh (5).png'
        },
        { id: 24, title: '海岛香氛蜡烛', english: 'ISLAND SCENTED CANDLE', sub1: '清新海风弥漫', sub2: '柑橘果香 安稳木质感', url: 'static/picture/FOLKTALE/list/xh/xh (2).png' },

        { id: 26, title: '绿茶香氛蜡烛', english: 'TEALIZZY SCENTED CANDLE', sub1: '温暖穿透藤蔓', sub2: '清新柑橘 清澈铃兰', url: 'static/picture/FOLKTALE/list/xh/xh (4).png' },

        {
          id: 28,
          title: '蒲公英域香氛蜡烛',
          english: 'DANDELION FIELDS SCENTED CANDLE',
          sub1: '永不停歇的爱',
          sub2: '微暖雪松 凛冽木香',
          url: 'static/picture/FOLKTALE/list/xh/xh (6).png'
        },

        {
          id: 30,
          title: '泌密忍冬&格蓬香氛蜡烛',
          english: 'HONEYSUCKLE & GALBANUM SCENTED CANDLE',
          sub1: '柔和明朗交织',
          sub2: '绵长茉莉 深沉檀香',
          url: 'static/picture/FOLKTALE/list/xh/xh (8).png'
        },

        {
          id: 32,
          title: '英国小苍梨香氛蜡烛',
          english: 'ENGLISH PEAR FREESIA SCENTED CANDLE',
          sub1: '初遇雨后森林',
          sub2: '清新香柠 温柔涤荡',
          url: 'static/picture/FOLKTALE/list/xh/xh (10).png'
        }
      ],
      list5: [
        { id: 9, title: '洗面奶起泡器', english: 'BUBBLE FORMER', sub1: '细腻融化少女心', sub2: '快速起泡 丰盈泡沫', url: 'static/picture/FOLKTALE/list/sh/sh (2).jpg' },
        { id: 14, title: '生活故事睡袍', english: 'NIGHT ROBE', sub1: '触手可及的柔软', sub2: '亲肤触感 柔软质感', url: 'static/picture/FOLKTALE/list/sh/sh (7).jpg' }
      ]
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.judgeLogin();
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: '/FolktaleDetail', query: { id: id } });
    },
    //跳转到外部链接
    linkOut(url) {
      if (url.includes('https://') || url.includes('http://')) {
        window.location.href = url;
      } else {
        window.location.href = `https://${url}`;
      }
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
/*------------luara.html  start----------------*/
.classify_box {
  width: 100%;
  height: 116px;
  overflow: hidden;
  background: #fafafa;
}
.classify_box p {
  margin-top: 12px;
  text-align: right;
  padding-right: 60px;
  font-size: 12px;
  color: #000000;
  font-family: Font_Light;
}
.classify_box select {
  width: 198px;
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #000;
  background: none;
  float: right;
  margin: 12px 30px 0 0;
  font-size: 14px;
  color: #000000;
  font-family: Font_Light;
}

.pro_box {
  overflow: hidden;
}
.pro_box li {
  width: 30%;
  margin: 5% 5% 8% 0;
  float: left;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.pro_box li:nth-child(3n) {
  margin: 5% 0 8% 0;
}
.pro_box li a {
  color: #000;
}
.pro_box li a:hover {
  color: #000;
}
.pro_box li i {
  padding: 0 10px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  letter-spacing: 1px;
  font-style: normal;
  font-size: 13px;
  font-family: Font_Regular;
  border: 1px solid #000;
  z-index: 2;
  margin: 40px auto 0;
}
.pro_box li .li_img {
  width: 100%;
  overflow: hidden;
  padding-top: 135%;
  position: relative;
}
.pro_box li .li_img img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.pro_box li .li_text {
  text-align: center;
}
.pro_box li .li_text p {
  letter-spacing: 2px;
  font-size: 15px;
  font-family: Font_Medium;
  margin: 0 0 10px 0;
}
.pro_box li .li_text p em {
  letter-spacing: 1px;
  display: block;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
.pro_box li .li_text span {
  display: inline-block;
  padding: 0 16px;
  text-align: center;
  letter-spacing: 2px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background: #000;
  font-size: 15px;
  font-family: Font_Normal;
}
/*------------luara.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Html/FOLKTALE.vue